import { isSjDomain, isKsDomain } from 'utils/domain'

/**
 * アップロード対象の画像の最大サイズ
 */
export const IMAGE_MAX_SIZE = 800

/**
 * SJのヘッダーの高さ
 */
export const SJ_HEADER_HEIGHT = 44

/**
 * 要請後テンプレートのRequestAreaの高さ
 */
export const REQUEST_AREA_HEIGHT =
  isSjDomain() || isKsDomain() ? `${400 + SJ_HEADER_HEIGHT}px` : `${400}px`

/**
 * 要請後テンプレートのLoaderBarのTop
 */
export const LOADER_BAR_TOP =
  isSjDomain() || isKsDomain() ? `${270 + SJ_HEADER_HEIGHT}px` : `${270}px`

/**
 * 要請後テンプレートのTrackingAreaの高さ
 */
export const TRACKING_AREA_HEIGHT =
  isSjDomain() || isKsDomain()
    ? `${window.innerHeight * 0.7 + SJ_HEADER_HEIGHT}px`
    : `${window.innerHeight * 0.7}px`

/**
 * 要請後テンプレートのTrackingMapの高さ
 */
export const TRACKING_MAP_HEIGHT = `${window.innerHeight * 0.7}px`
